module.exports = __webpack_public_path__ + "media/assets/icons/syohin-zyoho-icon-14db6b0412c7dbc9172749cfa62b5b70.svg";